import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const Encore = () => (
  <div>
    <h2>Encore</h2>
    <p>7 Channels of Premium Encore Content in HD. $7</p>
    <Button outline color="success" id="encoretoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#encoretoggle">
      <Card>
        <CardBody>
          435 - Starz Encore<br />
          436 - Starz Encore Action<br />
          437 - Starz Encore Black<br />
          438 - Starz Encore Classic<br />
          439 - Starz Encore Suspense<br />
          440 - Starz Encore Family<br />
          441 - Starz Encore Westerns<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default Encore;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/encore.js